<template>
    <transition name="router-fade" mode="out-in">
        <div>
            <router-view></router-view>
            <section class="landscape" v-show="landscape">
                <section class="alert_box">
                    <span>请使用竖屏打开</span>
                </section>
            </section>
        </div>
    </transition>
</template>
<script>
import {setCookie, getCookie, getUrlKeyValue, delCookie} from './config/mUtils'
import {getStore, savePackTime} from './config/tackPackTime'

    export default {
        data() {
            return {
                landscape: false
            }
        },
        watch: {
            '$route' (to, from) {
                //初始化拆书包数据
                if (getCookie('HTTP_X_YS_UID') != '' && getCookie('HTTP_X_YS_USER_TOKEN') != '') {
                    const readStore = JSON.parse(getStore('readMsg'));
                    const playStore = JSON.parse(getStore('playMsg'));
                    if (readStore || playStore) {
                        //离开页面存储时长
                        savePackTime();
                    }
                }
            },
        },
        beforeCreate(){

        },
        mounted() {
            console.log('App.vue mounted, xbranch', getUrlKeyValue('xbranch'))
            if (getUrlKeyValue('xbranch') == 'preview') {
                setCookie('x-branch', 'preview')
            } else {
                delCookie('x-branch')
            }
            window.addEventListener("resize", this.renderResize, false)
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.renderResize, false)
        },
        methods: {
            renderResize() {
                let clientWidth = document.documentElement.clientWidth;
                let clientHeight = document.documentElement.clientHeight;
                if (clientWidth > clientHeight) {
                    this.landscape = true
                } else {
                    this.landscape = false
                }
            }
        }
    }

</script>

<style lang="scss">
    @import 'style/_common.scss';
    @font-face {
        font-family: Gilroy-Regular;
        src: url('../public/static/gilroy-regular.otf');
    }
    @font-face {
        font-family: Gilroy-Bold;
        src: url('../public/static/gilroy-bold.otf');
    }
    html,body{
        height: 100%;
    }
    #app{
        height: 100%;
    }
    .landscape{
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10001;
        box-sizing: border-box;
        .alert_box{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 200px;
            height: 100px;
            transform: translate(-50%, -50%);
            color: #ffffff;
            font-size: 20px;
        }
    }
</style>
